(function($) {

  //markup:
  // <dl class="accordion">
  //      <dt id="pattern1_1"><button aria-expanded="false" aria-controls="pattern1_1_panel">Tab Title</button></dt>
  //      <dd id="pattern1_1_panel">Panel Content</dd>
  //      <dt id="pattern1_2"><button aria-expanded="false" aria-controls="pattern1_2_panel">Tab Title</button></dt>
  //      <dd id="pattern1_2_panel">Panel Content</dd>
  // </dl>

$.fn.accordion = function() {

    //VARIABLES
    var $accWrapper = $(this),
        $tabs = $accWrapper.children('dt');

    //FUNCTIONS
    var toggleAccPanelFn = function( $this_tab, $this_panel, forceOpen ){
          var $button = $this_tab.find('button');
          
          if( forceOpen || ($this_tab.hasClass('inactive') && !$this_panel.is(':visible')) ){
            $this_panel.slideDown();
            $this_tab.addClass('active').removeClass('inactive');
            $button.attr('aria-expanded', 'true');
            // Update URL hash without scrolling
            if( !forceOpen && history.pushState ){
                history.pushState(null, null, '#' + $this_tab.attr('id'));
            }
          }
          else if( $this_tab.hasClass('active') && $this_panel.is(':visible') ){
              $this_panel.slideUp();
              $this_tab.removeClass('active').addClass('inactive');
              $button.attr('aria-expanded', 'false');
          }
    };

    //BUTTON CLICKS
    $tabs.find('button').on('click', function(e){
        e.preventDefault();
        var this_tab = $(this).closest('dt');
        var this_panel = this_tab.next();

        toggleAccPanelFn(this_tab, this_panel, false);
    });

    //FUNCTION TO HANDLE HASHTAG OPENING
    var handleHashtagOpen = function(){
        var hashtag = window.location.hash;
        var panelId = hashtag.replace('#','');
        
        if( hashtag ){
            // Check if hash matches a dt id or dd id (panel)
            var selected_tab = $accWrapper.children('dt#'+panelId);
            var selected_panel = selected_tab.next();
            
            // If the hash is a panel id, get the corresponding dt
            if( selected_tab.length === 0 ){
                selected_panel = $accWrapper.children('dd#'+panelId);
                if( selected_panel.length > 0 ){
                    selected_tab = selected_panel.prev('dt');
                }
            }
            
            if( selected_tab.length > 0 ){
                selected_panel = selected_tab.next();
                toggleAccPanelFn(selected_tab, selected_panel, true);

                var accordionPos = selected_tab.offset().top - 50;
                $('html, body').animate( { scrollTop : accordionPos }, 500 );
            }
        }
    };

    //PRESELECTED OPEN PANEL (USE OF HASHTAGS) - on page load
    handleHashtagOpen();

    //HANDLE HASH CHANGES (clicking anchor links on same page)
    $(window).on('hashchange', function(){
        handleHashtagOpen();
    });
};

})(jQuery);
